const ADFOX_EVENTS = {
  ADFOX_PLACEMENT_IMPRESSION: 'ADFOX_PLACEMENT_IMPRESSION',
  ADFOX_CREATIVE_IMPRESSION: 'ADFOX_CREATIVE_IMPRESSION',
  ADFOX_TAP_ON_BANNER: 'ADFOX_TAP_ON_BANNER',
  ADFOX_STUB: 'ADFOX_STUB',
  ADFOX_ERROR: 'ADFOX_ERROR'
};

export {ADFOX_EVENTS};
